import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F163jAutoEpService {

  constructor(private http: HttpClient) {}

  postEPData(
    params: any,
    globalService: any,
    GENERAL_CONFIG: any
  ): Observable<any> {
    
    // ✅ CRITICAL: Don't set Content-Type for FormData - browser sets it with boundary
    const headers = new HttpHeaders({
      'Accept': 'application/json'
      // DO NOT set Content-Type for FormData!
    });

    // Build request following original service pattern - matches JsonObjectFactory.saveJSON
    const baseUrl = GENERAL_CONFIG.base_url;
    const endpoint = `${baseUrl}/saveJsonObject?action_code=gqc24t`;

    // Build complete parameters object including global params
    const requestParams = Object.assign({}, globalService?.globalParams || {}, params);

    // ✅ Convert requestParams to FormData with proper type handling
    const formData = new FormData();
    Object.keys(requestParams).forEach(key => {
      const value = requestParams[key];
      
      // ✅ Handle different data types properly
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          // Convert objects/arrays to JSON strings
          formData.append(key, JSON.stringify(value));
        } else {
          // Convert primitives to strings
          formData.append(key, String(value));
        }
      }
      // Skip null/undefined values
    });

    // ✅ Debug FormData contents (alternative method for older TypeScript)
    console.log('FormData created with keys:', Object.keys(requestParams));
    console.log('Original requestParams:', requestParams);

    return this.http.post<any>(
      endpoint,
      formData,
      { headers: headers }
    );
  }
}